export default __webpack_public_path__ + "assets/app-store.ef33a8c1fafedcbbade8f106f6ad92a2.svg";